/**
 * Monsave FAQ Page Client-Side Search & Interaction Module
 */
document.addEventListener('DOMContentLoaded', function () {
    const searchInput = document.getElementById('faqSearchInput');
    const clearBtn = document.getElementById('faqSearchClearBtn');
    const faqItems = document.querySelectorAll('.faq-search-item');
    const emptyState = document.getElementById('faqSearchEmptyState');

    if (!searchInput) return;

    function performSearch(query) {
        const cleanQuery = query.trim().toLowerCase();
        let matchCount = 0;

        if (clearBtn) {
            clearBtn.style.display = cleanQuery.length > 0 ? 'inline-flex' : 'none';
        }

        faqItems.forEach(function (item) {
            if (cleanQuery.length === 0) {
                item.classList.remove('d-none');
                item.classList.remove('faq-search-matched');
                const collapseEl = item.querySelector('.accordion-collapse');
                if (collapseEl && !item.hasAttribute('data-default-open')) {
                    // close if it wasn't opened by default
                    if (collapseEl.classList.contains('show')) {
                        const bsCollapse = bootstrap.Collapse.getInstance(collapseEl);
                        if (bsCollapse) bsCollapse.hide();
                    }
                }
                matchCount++;
                return;
            }

            const text = (item.getAttribute('data-search-text') || item.innerText || '').toLowerCase();
            if (text.includes(cleanQuery)) {
                item.classList.remove('d-none');
                item.classList.add('faq-search-matched');
                matchCount++;

                // Automatically expand matched accordion item for convenience
                const collapseEl = item.querySelector('.accordion-collapse');
                if (collapseEl && !collapseEl.classList.contains('show')) {
                    const bsCollapse = bootstrap.Collapse.getOrCreateInstance(collapseEl, { toggle: false });
                    bsCollapse.show();
                }
            } else {
                item.classList.add('d-none');
                item.classList.remove('faq-search-matched');
            }
        });

        if (emptyState) {
            if (cleanQuery.length > 0 && matchCount === 0) {
                emptyState.classList.remove('d-none');
            } else {
                emptyState.classList.add('d-none');
            }
        }
    }

    searchInput.addEventListener('input', function (e) {
        performSearch(e.target.value);
    });

    if (clearBtn) {
        clearBtn.addEventListener('click', function () {
            searchInput.value = '';
            performSearch('');
            searchInput.focus();
        });
    }

    // Hash navigation for tabs
    const hash = window.location.hash;
    if (hash) {
        const tabTrigger = document.querySelector(`a[href="${hash}"]`);
        if (tabTrigger) {
            const tabInstance = bootstrap.Tab.getOrCreateInstance(tabTrigger);
            tabInstance.show();
        }
    }

    // Update URL hash on tab change without jump
    const tabLinks = document.querySelectorAll('#v-pills-tab a[data-bs-toggle="pill"]');
    tabLinks.forEach(function (tabLink) {
        tabLink.addEventListener('shown.bs.tab', function (e) {
            const targetHash = e.target.getAttribute('href');
            if (targetHash && history.replaceState) {
                history.replaceState(null, null, targetHash);
            }
        });
    });
});

